(() => {
  const init = (root) => {
    if (!root || root.dataset.vsReady === 'true') return;
    root.dataset.vsReady = 'true';
    const drawer = root.querySelector('[data-vs-drawer]');
    if (!drawer || !root.querySelector('[data-vs-filter-open]')) return;
    const closeDrawer = () => {
      drawer.hidden = true;
      document.body.classList.remove('nas-vs-drawer-open');
      const trigger = root.querySelector('[data-vs-filter-open]');
      trigger?.setAttribute('aria-expanded', 'false');
      trigger?.focus({ preventScroll: true });
    };
    const openDrawer = () => {
      drawer.hidden = false;
      document.body.classList.add('nas-vs-drawer-open');
      root.querySelector('[data-vs-filter-open]')?.setAttribute('aria-expanded', 'true');
      drawer.querySelector('.nas-vs-drawer__close')?.focus({ preventScroll: true });
    };
    root.addEventListener('click', (event) => {
      if (event.target.closest('[data-vs-filter-open]')) openDrawer();
      if (event.target.closest('[data-vs-filter-close]')) closeDrawer();
    });
    drawer.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeDrawer();
    });
  };
  const boot = () => document.querySelectorAll('[data-vs-collection]').forEach(init);
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
